import React, { useState, useEffect } from "react";
import "./payment-page.css";

import {
  createOrder,
  verifyPayment,
  getWalletBalance
} from "../../../services/payment/paymentservice";

import { useNavigate } from "react-router-dom";

const PaymentPage = () => {
  const navigate = useNavigate();

  const [wallet, setWallet] = useState({
    currentBalance: 0,
  });

  const [loading, setLoading] = useState(false);

const [amount, setAmount] = useState("");

const [paymentSummary, setPaymentSummary] = useState({
  rechargeAmount: 0,
  platformFeeGst: 0,
  gstAmount: 0,
  totalAmount: 0,
});
  const [client, setClient] = useState({
    name: "Client",
    email: "client@gmail.com",
    phone: "9876543210",
  });
  const loadWallet = async () => {
  try {
    const response = await getWalletBalance();

    setWallet(response.data);
  } catch (err) {
    console.error("Unable to fetch wallet", err);
  }
};
useEffect(() => {
  loadWallet();
}, []);

const rechargeAmount = Number(amount) || 0;

// Platform Fee (2.36%)
const platformFee = Number((rechargeAmount * 0.0236).toFixed(2));

// GST (18%)
const gstAmount = Number((rechargeAmount * 0.18).toFixed(2));

// Total Payable
const totalAmount = Number(
  (rechargeAmount + platformFee + gstAmount).toFixed(2)
);

  const handlePayment = async () => {
    if (!amount || Number(amount) <= 0) {
      alert("Please enter a valid amount");
      return;
    }

    if (Number(amount) > 100000) {
      alert("Maximum payment amount allowed is ₹100000");
      return;
    }

    try {
      setLoading(true);

   const orderResponse = await createOrder({
  amount: Number(amount),
});

      const orderData = orderResponse.data;

      setPaymentSummary({
  rechargeAmount: Number(amount),
  platformFeeGst: orderData.platformFeeGst,
  gstAmount: orderData.gstAmount,
  totalAmount: orderData.amount,
});



     const options = {
  key: orderData.key,

  // Razorpay expects amount in paise
  amount: Number(orderData.amount) * 100,

  currency: orderData.currency,

  name: "TrueFace",

  description: "Background Verification Fee",

  order_id: orderData.orderId,

        handler: async function (response) {
          try {
            const payload = {
              razorpayOrderId: response.razorpay_order_id,

              razorpayPaymentId: response.razorpay_payment_id,

              razorpaySignature: response.razorpay_signature,

              paymentMode: "CARD",
            };

            await verifyPayment(payload);
            await loadWallet();

            navigate("/client/payment-success", {
              state: {
                paymentId: response.razorpay_payment_id,
              },
            });
          } catch (error) {
            console.error("Payment verification failed", error);

            navigate("/client/payment-failed");
          }
        },

        prefill: {
          name: client.name,

          email: client.email,

          contact: client.phone,
        },

        theme: {
          color: "#3399cc",
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on("payment.failed", function (response) {
        console.error("Payment Failed", response.error);

        navigate("/client/payment-failed");
      });

      razorpay.open();
    } catch (error) {
      console.error("Order Creation Failed", error);

      alert(error?.response?.data?.message || "Unable to create order");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="paymentPage-container">
      <div className="paymentPage-wrapper">
        {/* Payment Form */}
        <div className="paymentPage-card">
          <div className="paymentPage-header">
            <h2>Background Verification Payment</h2>
            <p>Secure payment powered by Razorpay</p>
          </div>

          {/* <div className="paymentPage-row">
                    <label>Client </label>
                    <div className="paymentPage-value">
                        #{clientId}
                    </div>
                </div> */}

          <div className="paymentPage-row">
            <label>Current Balance</label>
            <div className="paymentPage-value">
              ₹{wallet?.currentBalance ?? 0}
            </div>
          </div>

          {(wallet?.currentBalance ?? 0) < 5000 && (
          <div className="payment-warning">
            ⚠️ Your wallet balance is below ₹5,000. Please recharge to continue uninterrupted verification services.
          </div>
          )}

          <div className="paymentPage-row">
            <label htmlFor="amount">Enter Amount</label>

            <input
              id="amount"
              type="number"
              value={amount}
              min={0}
              max={100000}
              step={1}
              onChange={(e) => {
                let value = e.target.value;

                if (value === "") {
                  setAmount("");
                  return;
                }
                value = Number(value);

                if(value < 0) {
                  value = 0;
                }

                if(value > 100000) {
                  value = 100000;
                }

                setAmount(value);
              }}

              onKeyDown={(e) => {

                if(["-", "+", "e", "E"].includes(e.key)) {
                  e.preventDefault();
                }
              }}

              onPaste={(e) => {
              const pasted = e.clipboardData.getData("text");

              if (Number(pasted) < 0) {
              e.preventDefault();
             }
            }}
              placeholder="Enter amount"
              // min="1"
              // max="100000"
              className="paymentPage-input"
            />
          </div>

          <div className="payment-total-cont">
 <div className="paymentPage-total">
  <div>Wallet Credit : ₹{rechargeAmount.toFixed(2)}</div>

  <div>
    Platform Fee (2.36%) : ₹{platformFee.toFixed(2)}
  </div>

  <div>
    GST (18%) : ₹{gstAmount.toFixed(2)}
  </div>

  <div>
    <strong>
      Total Payable : ₹{totalAmount.toFixed(2)}
    </strong>
  </div>
</div>

            <button
              className="paymentPage-button"
              onClick={handlePayment}
              disabled={
                loading ||
                !amount ||
                Number(amount) <= 0 ||
                Number(amount) > 100000
              }
            >
              {loading ? "Processing..." : "Pay Now"}
            </button>
          </div>
        </div>

        {/* Payment Summary */}
        <div className="paymentSummary-card">
          <h3>Payment Summary</h3>
<div className="summary-row">
  <span>Recharge Amount</span>
  <span>₹{rechargeAmount.toFixed(2)}</span>
</div>

<div className="summary-row">
  <span>Platform Fee (2.36%)</span>
  <span>₹{platformFee.toFixed(2)}</span>
</div>

<div className="summary-row">
  <span>GST (18%)</span>
  <span>₹{gstAmount.toFixed(2)}</span>
</div>

<div className="summary-divider"></div>

<div className="summary-total">
  <span>Total Payable</span>
  <span>₹{totalAmount.toFixed(2)}</span>
</div>
          <div className="summary-badges">
            <div className="summary-badge secure">🔒 Secure Payment</div>

            <div className="summary-badge instant">⚡ Instant Confirmation</div>

            <div className="summary-badge razorpay">💳 Razorpay Gateway</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPage;
